import * as service from './service'
export default {
  namespace: 'scanToOrderQrCode',
  state: {
    demoData: {}
  },
  effects: {
    * getQRCode ({ payload }, { call, put }) {
      const res = yield call(service.getQRCode, payload)
      return res.data
    },
    * queryCourierSurplusCount ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierSurplusCount, payload)
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
